import { useQaNamespace } from '@Framework/ui/quality-assurance';
import { Typography } from '@material-ui/core';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React, { useMemo } from 'react';

import { TextProps } from './index';
import { DISPLAY, TEXT_TYPES, TEXT_VARIANTS } from './Text.types';

/**
 * Text Component to Suit the Abstract Framework needs
 */
const Text = ({
  name = undefined,
  type = TEXT_TYPES.DARK_GRAY,
  variant = TEXT_VARIANTS.BODY1,
  text,
  isBold = false,
  isUnderlined = false,
  isItalic = false,
  style,
  className,
  gutterBottom = false,
  component,
  display = DISPLAY.BLOCK
}: TextProps): React.ReactElement => {
  // Font Sizes are applied over the Mui theme Provider
  const textStyles: React.CSSProperties = useMemo(() => {
    // Color Switch
    const map = {
      [TEXT_TYPES.BLUE]: CORPORATE_COLORS.BLUE,
      [TEXT_TYPES.PRIMARY]: CORPORATE_COLORS.TEXT_PRIMARY,
      [TEXT_TYPES.LIGHT_BLUE]: CORPORATE_COLORS.LIGHT_BLUE,
      [TEXT_TYPES.DISABLED]: CORPORATE_COLORS.DISABLED,
      [TEXT_TYPES.OUTLINE]: CORPORATE_COLORS.DISABLED,
      [TEXT_TYPES.GREEN]: CORPORATE_COLORS.GREEN,
      [TEXT_TYPES.RX]: CORPORATE_COLORS.RX,
      [TEXT_TYPES.RED]: CORPORATE_COLORS.RED,
      [TEXT_TYPES.ORANGE]: CORPORATE_COLORS.ATTENTION,
      [TEXT_TYPES.GRAY]: CORPORATE_COLORS.GRAY,
      [TEXT_TYPES.LIGHT_GRAY]: CORPORATE_COLORS.LIGHT_GRAY,
      [TEXT_TYPES.LIGHT_GRAY_DARK]: CORPORATE_COLORS.LIGHT_GRAY_DARK,
      [TEXT_TYPES.DARK_GRAY]: CORPORATE_COLORS.DARK_GRAY,
      [TEXT_TYPES.WHITE]: CORPORATE_COLORS.WHITE
    };

    const color: string = map[type];

    return {
      color,
      fontStyle: isItalic ? 'italic' : undefined,
      fontWeight: isBold ? 'bold' : undefined,
      textDecoration: isUnderlined ? 'underline' : undefined,
      ...style
    };
  }, [type, isBold, isUnderlined, style]);

  const dataQaId = name ? useQaNamespace({ suffix: name }) : undefined;

  return (
    // @ts-ignore Typings are currently broken, see https://github.com/mui-org/material-ui/issues/20373
    <Typography
      element={component}
      style={textStyles}
      className={className}
      variant={variant}
      data-qa-id={dataQaId}
      gutterBottom={gutterBottom}
      display={display}
    >
      {text}
    </Typography>
  );
};

export { Text };
